import { motion } from 'framer-motion';
import styled from 'styled-components';

import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

const { min, threeFourth } = layout.columns;

export const Wrapper = styled(motion.ul)`
  display: grid;
  grid-gap: 17px;
  grid-template-columns: repeat(${min}, minmax(0px, 1fr));
  grid-column: 1/-1;

  ${mediaTablet(`
    grid-gap: 32px;
    grid-template-columns: repeat(${min}, minmax(0px, 1fr));
    grid-column: 2/12;
  `)}

  ${mediaDesktop(`
    grid-template-columns: repeat(${threeFourth}, minmax(0px, 1fr));
  `)}
`;
